module.exports = __webpack_public_path__ + "components/weather-icon/static/nightrainshowers-fdd5239348f6e287492f6f267438893a.svg";